// @ts-nocheck
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { FormFieldPresentationProps } from "@insite/mobius/FormField";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export interface InlineFormProps {
    wrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
    field?: FormFieldPresentationProps<any>;
    fieldWrapper?: InjectableCss;
    button?: ButtonPresentationProps;
    buttonWrapper?: InjectableCss;
}

export const inlineFormGap = pxToRem(10);

const wrapperProps: InjectableCss = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        gap: ${inlineFormGap};
    `,
};

const fieldWrapperProps: InjectableCss = {
    css: css`
        display: flex;
        flex-grow: 99;
        width: auto;
    `,
};

export const inlineFormProps: InlineFormProps = {
    wrapper: wrapperProps,
    innerWrapper: mergeProps<InlineFormProps["innerWrapper"]>(wrapperProps, fieldWrapperProps),
    field: {
        sizeVariant: "default",
        cssOverrides: {
            formField: css`
                ${x => x.theme.formField.defaultProps?.cssOverrides?.formField}
                ${fieldWrapperProps.css}
                width: auto;
            `,
        },
    },
    fieldWrapper: fieldWrapperProps,
    button: {
        variant: "primary",
        sizeVariant: "medium", // Store Custom Code
        css: css`
            ${x => x.theme.button.primary.css}
            flex-grow: 1;
        `,
    },
    buttonWrapper: {
        css: css`
            display: flex;
            flex-grow: 1;
            width: auto;
        `,
    },
};

const wrapperWithLabelProps = mergeProps<InlineFormProps["wrapper"]>(inlineFormProps.wrapper, {
    css: css`
        ${({ theme }) => breakpointValues(theme.design.form.grid.base.vertical, "row-gap")}
    `,
});

export const inlineFormWithLabelProps: InlineFormProps = {
    ...inlineFormProps,
    wrapper: wrapperWithLabelProps,
    innerWrapper: mergeProps<InlineFormProps["innerWrapper"]>(wrapperWithLabelProps, fieldWrapperProps),
    button: mergeProps<InlineFormProps["button"]>(inlineFormProps.button, {
        css: css`
            ${({ theme }) =>
                breakpointValues(
                    theme.design.form.grid.base.vertical.map(x =>
                        x ? `calc(${theme.design.form.actions.spacing} - ${x})` : null,
                    ),
                    "margin-top",
                )}
        `,
    }),
};
